<template lang="pug">
v-app
    v-container(fluid, fill-height)
        v-layout(align-center, justify-center)
            v-flex(xs12, sm8, md4)
                router-view
</template>

<script>
export default {
    data() {
        return {
      //
        }
    },
    created() {
    //
    },
}
</script>
